// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__31U0y","title":"Info_title__1qzAe","selects":"Info_selects__GvjzA","requiredAsterisk":"Info_requiredAsterisk__2pd6d"};